export class Settings {
    public constructor(settings: any) {
        Object.assign(this, settings);
    }
}
export interface Settings {
    base: string;
    url(url: string): string;
    name: string;
    program: string;
    author: string;
    description: string;
    card: string;
    cardMagenta: string;
    minDate: string;
    mainMenu: Array<{ icon: [string, string]; title: string; to: string; exact: boolean }>;
    errorPages: {
        default: { icon: [string, string]; title: string; message: string; statusCode: number };
        [code: string]: { icon: [string, string]; title: string; message: string; statusCode: number };
    };
    cardTypeQuestionId: string;
    cardTypeAnswerId: string;
    programId: string;
    surveyId: string;
    eligibilityCitizenId1: string;
    eligibilityCitizenId1Yes: string;
    eligibilityPrescriptionId2: string;
    eligibilityPrescriptionId2Yes: string;
    eligibilityPrescriptionDiagnosisId3: string;
    eligibilityPrescriptionDiagnosisId3Yes: string;
    eligibilityPatientIdentificationId4: string;
    eligibilityPatientIdentificationIdOption1: string;
    eligibilityPatientIdentificationIdOption2: string;
    eligibilityPatientIdentificationIdOption3: string;
    eligibilityPharmacistDocumentationId5: string;
    eligibilityPharmacistDocumentationId5Yes: string;
    eligibilityDrugCoverageId6: string;
    eligibilityDrugCoverageId6Yes: string;
    eligibilityFederalInsuranceId7: string;
    eligibilityFederalInsuranceId7No: string;
    eligibilityWelcomeLetterId8: string;
    eligibilityWelcomeLetterId8Yes: string;
    eligibilityHealthInformationId9: string;
    eligibilityHealthInformationId9Yes: string;
    eligibilityPatientTermsAndConditionsId10: string;
    eligibilityPatientTermsAndConditionsId10Yes: string;
    eligibilityPharmacistTermsAndConditionsId11: string;
    eligibilityPharmacistTermsAndConditionsId11Yes: string;
}
